import React from 'react';

import {useI18n} from '@udemy/i18n';

import styles from './career-stats.module.less';

export const CareerStats = () => {
    const {gettext} = useI18n();

    return (
        <section className={styles.container}>
            <h2 className={styles.title}>
                {gettext('Build the essential AI skills employers are looking for')}
            </h2>
            <div className={styles.content}>
                <div className={styles.card}>
                    <span className={`${styles.stat} ${styles.purple}`}>108%</span>
                    <p className={styles.description}>
                        {gettext('increase in job postings mentioning AI over the past 2 years')}
                        {' ¹'}
                    </p>
                </div>
                <div className={styles.card}>
                    <span className={`${styles.stat} ${styles.teal}`}>56%</span>
                    <p className={styles.description}>
                        {gettext("wage premium for workers skilled in AI versus those who aren't")}
                        {' ²'}
                    </p>
                </div>
                <div className={styles.card}>
                    <span className={`${styles.stat} ${styles.orange}`}>83%</span>
                    <p className={styles.description}>
                        {gettext('of workers say AI tools support new skill development')}
                        {' ³'}
                    </p>
                </div>
            </div>
        </section>
    );
};
